module.exports = __webpack_public_path__ + "img/ltkasia-4x.881ffbb.jpg";